import * as SDK from "azure-devops-extension-sdk";
import { buildBranchName, validate } from "./branchName.js";
import { createBranch, linkBranchToWorkItem, listBranches, listRepos, getWorkItemTitle, branchUrl, } from "./ado.js";
const $ = (id) => document.getElementById(id);
let repos = [];
let branches = [];
function currentName() {
    return buildBranchName({
        workItem: $("workItem").value,
        description: $("desc").value,
        fromMain: $("fromMain").checked,
    });
}
function setStatus(text, kind) {
    const el = $("status");
    el.textContent = text || " ";
    el.className = `status ${kind}`;
}
function refresh() {
    const name = currentName();
    $("preview").textContent = name || " ";
    const error = validate(name);
    setStatus(error ?? "matches convention", error ? "err" : "ok");
    $("create").disabled = !!error;
}
/**
 * Closing is owned by the host frame. The handle lives on the configuration
 * object the host injects. Guarded so a shape change degrades to a logged
 * error instead of a dead button. See README "Verify before you trust it".
 */
function close(result) {
    const cfg = SDK.getConfiguration();
    if (typeof cfg?.dialog?.close === "function")
        cfg.dialog.close(result);
    else if (typeof cfg?.close === "function")
        cfg.close(result);
    else
        console.error("No dialog close handle on configuration", cfg);
}
async function loadBranches(repo) {
    const source = $("source");
    source.innerHTML = `<option>loading…</option>`;
    branches = await listBranches(repo.id);
    const short = (r) => r.name.replace("refs/heads/", "");
    source.innerHTML = branches
        .map((r) => `<option value="${r.objectId}">${short(r)}</option>`)
        .join("");
    const preferred = branches.find((r) => r.name === repo.defaultBranch);
    if (preferred)
        source.value = preferred.objectId;
    syncFromMain();
}
function syncFromMain() {
    const selected = branches.find((r) => r.objectId === $("source").value);
    $("fromMain").checked = selected?.name === "refs/heads/main";
    refresh();
}
async function onCreate() {
    const button = $("create");
    const repo = repos.find((r) => r.id === $("repo").value);
    const name = currentName();
    button.disabled = true;
    setStatus("creating…", "");
    try {
        await createBranch(repo.id, name, $("source").value);
    }
    catch (e) {
        setStatus(String(e instanceof Error ? e.message : e), "err");
        button.disabled = false;
        return;
    }
    // Branch exists from here on — a failed link must not look like a failed
    // create, so it keeps the dialog open with the reason instead of retrying.
    const workItem = $("workItem").value.trim();
    if (workItem) {
        try {
            await linkBranchToWorkItem(workItem, repo, name);
        }
        catch (e) {
            setStatus(`Branch created, but linking #${workItem} failed: ${e instanceof Error ? e.message : e}`, "err");
            return;
        }
    }
    close({ name, url: branchUrl(repo, name) });
}
async function prefillFromWorkItem(id) {
    $("workItem").value = String(id);
    refresh();
    try {
        const title = await getWorkItemTitle(id);
        // Only fill the description if the user hasn't started typing over it.
        if (title && !$("desc").value) {
            $("desc").value = title;
            refresh();
        }
    }
    catch (e) {
        // Id is prefilled either way; the title is a convenience, not a dependency.
        console.warn("Could not read work item title", e);
    }
}
function mockHost() {
    document.body.classList.add("standalone");
    $("repo").innerHTML = ["BIC / BIC", "BIC / brisk-design-system"]
        .map((n) => `<option>${n}</option>`)
        .join("");
    branches = [
        { name: "refs/heads/develop", objectId: "a".repeat(40) },
        { name: "refs/heads/main", objectId: "b".repeat(40) },
    ];
    $("source").innerHTML = branches
        .map((r) => `<option value="${r.objectId}">${r.name.replace("refs/heads/", "")}</option>`)
        .join("");
    $("workItem").value = "7152";
    $("desc").value = "Clu import scaling fix";
    refresh();
}
async function main() {
    $("workItem").addEventListener("input", refresh);
    $("desc").addEventListener("input", refresh);
    $("fromMain").addEventListener("change", refresh);
    $("source").addEventListener("change", syncFromMain);
    $("cancel").addEventListener("click", () => close());
    $("create").addEventListener("click", onCreate);
    // Standalone dev: no ADO host, so SDK.init()'s postMessage handshake would
    // never resolve. Fake the data instead so the layout is actually checkable.
    if (window.parent === window)
        return mockHost();
    // loaded defaults to true: the form is usable immediately and each async bit
    // has its own "loading…" state. Gating on loaded:false hid the whole body
    // behind the host overlay until every request finished — including failures.
    await SDK.init({ applyTheme: true });
    await SDK.ready();
    console.log("[custom-branch] dialog ready", SDK.getConfiguration());
    // The dialog iframe has no intrinsic height — the host only sizes it when the
    // content asks. Resizing once at the end of main() left the modal at 0px
    // (i.e. empty) for the whole load, and forever if a request failed.
    // ponytail: observer instead of resize calls at each mutation site; also
    // covers the error <pre> the catch below installs.
    new ResizeObserver(() => SDK.resize()).observe(document.body);
    SDK.resize();
    const cfg = SDK.getConfiguration();
    const hint = cfg?.repositoryId;
    // Invoked from a work item: prefill id + description from its title. Runs
    // alongside the repo load, and a failure here must not block the dialog.
    const prefill = cfg?.workItemId
        ? prefillFromWorkItem(cfg.workItemId)
        : Promise.resolve();
    repos = await listRepos();
    $("repo").innerHTML = repos
        .map((r) => `<option value="${r.id}">${r.project.name} / ${r.name}</option>`)
        .join("");
    const selected = repos.find((r) => r.id === hint) ?? repos[0];
    if (selected) {
        $("repo").value = selected.id;
        await loadBranches(selected);
    }
    $("repo").addEventListener("change", () => loadBranches(repos.find((r) => r.id === $("repo").value)));
    await prefill;
}
main().catch((e) => {
    console.error("[custom-branch] dialog failed", e);
    document.body.innerHTML = `<pre style="color:#a4262c">${e instanceof Error ? e.stack : e}</pre>`;
});
